import React, { useEffect, useState } from 'react'
import Users from './Users'
import MainLinks from '../navlinks/MainLinks'
import Body from '../body/BodyPage'
import { useTranslation } from "react-i18next";
import {
    MDBBreadcrumb,
    MDBBreadcrumbItem,
} from "mdb-react-ui-kit";
import { getUsersPartOfGroups } from '../../apiclients/streamsapi_bridge';
import { useLocation, useNavigate } from 'react-router';

function UsersPartOfGroup() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [addUsers, setAddUsers] = useState(false);
    const [groupInfo, setGroupInfo] = useState(
        location?.state?.tab ? location?.state?.tab : location.state ? location.state : {}
    );
    const [userList, setuserList] = useState([]);
    console.log("location details ::::::: " + JSON.stringify(groupInfo));

    async function fetchUsersPartOfGroup() {
        try {
            const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const groupcode = groupInfo.entity_id;
            console.log("group code is ::::::" + groupcode + " group type ::::::: " + groupInfo.type);
            const extraCondition = `?group_type=${groupInfo.type}`
            let serverResponse = await getUsersPartOfGroups(siteid, groupcode, extraCondition);
            if (!serverResponse.json) {
                const message = `An error has occured: ${serverResponse.statusText}`;
                return;
            }
            const rawData = await serverResponse.json();
            if (!rawData) {
                window.alert(`info with id  not found`);
                navigate("/");
            }
            console.log("location users :::::: " + JSON.stringify(rawData));
            setuserList(rawData.group_members ?? []);

        } catch (error) {
            console.log(`Error in getLocUsers ${error}`);
        }
    }
    useEffect(() => {
        if (groupInfo.entity_id) {
            fetchUsersPartOfGroup();

        }

    }, [groupInfo.entity_id])
    return (
        <React.Fragment>
            <MainLinks active={3} />
            <Body
                tablinks={3}
                sublink={8}
                content={
                    <>
                        <section className="mb-3">
                            <div className="card card-height">
                                <div className="card-header px-0">
                                    <h5 className="mb-0">
                                        <MDBBreadcrumb>
                                            <MDBBreadcrumbItem>
                                                <a onClick={(e) => {
                                                    navigate("/userlanding", {
                                                        state: { tab: "suser", tab2: "suser" },
                                                    });
                                                }}>
                                                    <strong>{t("users")}</strong>
                                                </a>
                                            </MDBBreadcrumbItem>
                                            <MDBBreadcrumbItem active>
                                                <a onClick={(e) => {
                                                    navigate("/userlanding", {
                                                        state: { tab: "suser", tab2: "sgroups" },
                                                    });
                                                }}>
                                                    <strong>All {t("groups")}</strong>
                                                </a>
                                            </MDBBreadcrumbItem>
                                            <MDBBreadcrumbItem>
                                                <a href="">
                                                    <strong>{`${groupInfo.title} : ${groupInfo.group_type}`} </strong>
                                                </a>
                                            </MDBBreadcrumbItem>
                                        </MDBBreadcrumb>
                                    </h5>
                                </div>
                                <div className="card-body usersTab_btns px-0">
                                    <div className="pb-2">
                                        <h5 className="fw-600 mt-2 ">
                                            {groupInfo.title}
                                        </h5>
                                        <p className="mt-2 text-secondary">
                                            {groupInfo.group_type}
                                        </p>
                                        <h6 className="mt-2">
                                        </h6>
                                    </div>
                                    <Users addUsers={addUsers} userList={userList} groupInfo={groupInfo}/>
                                </div>
                            </div>
                        </section>
                    </>
                }
            />
        </React.Fragment>
    )
}

export default UsersPartOfGroup
